import { buttonClasses, Grid, styled } from '@mui/material';
import { LwButton } from 'redesign';
import { IconTrash } from 'assets/img';
import { useTranslation } from 'react-i18next';
import { ConditionTimeInput } from './inputs/condition-time-input';
import { PreferredWorkerMultiSelect, WorkerOption } from './inputs/preferred-worker-multiselect';

type PreferredWorkerRuleProps = {
  index: number;
  workerOptions: WorkerOption[];
  disabled?: boolean;
  handleDelete: (index: number) => void;
  isLoadingWorkerOptions?: boolean;
  onWorkerSearchChange?: (search: string) => void;
};

export const PreferredWorkerRule = ({
  index,
  workerOptions,
  disabled,
  handleDelete,
  isLoadingWorkerOptions,
  onWorkerSearchChange,
}: PreferredWorkerRuleProps) => {
  const { t } = useTranslation('web-common');

  return (
    <Grid container item xs={12} rowSpacing={4}>
      <Grid container item xs={12} columnSpacing={6} alignItems="center">
        <Grid item xs={4}>
          <ConditionTimeInput index={index} disabled={disabled} />
        </Grid>
        <Grid item xs={8} display="flex" justifyContent="flex-end">
          <DeleteButton
            startIcon={<IconTrash width={18} height={18} />}
            disabled={disabled}
            color="tertiary"
            onClick={() => handleDelete(index)}
          >
            {t('buttons.delete')}
          </DeleteButton>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <PreferredWorkerMultiSelect
          workerOptions={workerOptions}
          index={index}
          disabled={disabled}
          isLoading={isLoadingWorkerOptions}
          onSearchChange={onWorkerSearchChange}
        />
      </Grid>
    </Grid>
  );
};

const DeleteButton = styled(LwButton)(({ theme }) => ({
  [`&.${buttonClasses.root}`]: {
    '& svg path': {
      stroke: theme.palette.lwDanger[100],
      fill: 'none',
    },
  },
  [`&.${buttonClasses.root}.${buttonClasses.contained}Tertiary svg path`]: {
    stroke: theme.palette.lwDanger[100],
    fill: 'none',
  },
  [`&.${buttonClasses.contained}Tertiary`]: {
    border: `1px solid ${theme.palette.lwDanger[100]}`,
    color: theme.palette.lwDanger[100],
    [`&.${buttonClasses.disabled}`]: {
      color: theme.palette.lwDanger[100],
    },
    '&:hover': {
      border: `1px solid ${theme.palette.lwDanger[100]}`,
      boxShadow: `0px 6px 16px ${theme.palette.lwDanger[20]}`,
      textDecoration: 'none',
    },
  },
}));
